(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      
      // Initialize language selector
      this.initLanguageSelector();
    }
    
    initLanguageSelector() {
      const langButtons = document.querySelectorAll('[data-lang-selector]');
      const langLists = document.querySelectorAll('[data-lang-list]');
      
      if (langButtons.length === 0) return;
      
      // Toggle language dropdown
      langButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.stopPropagation();
          const list = button.nextElementSibling;
          const isVisible = list.classList.contains('disclosure__list--visible');
          
          // Close all other dropdowns
          langLists.forEach(l => {
            if (l !== list) {
              l.classList.remove('disclosure__list--visible');
            }
          });
          
          // Toggle current dropdown
          list.classList.toggle('disclosure__list--visible', !isVisible);
          button.setAttribute('aria-expanded', !isVisible);
        });
      });
      
      // Handle language selection
      langLists.forEach(list => {
        list.querySelectorAll('a').forEach(item => {
          item.addEventListener('click', (e) => {
            e.preventDefault();
            const form = item.closest('form');
            const input = form.querySelector('input[name="locale_code"]');
            input.value = item.dataset.value;
            form.submit();
          });
        });
      });
      
      // Close dropdown when clicking outside
      document.addEventListener('click', (e) => {
        const isClickInside = e.target.closest('.disclosure');
        if (!isClickInside) {
          langLists.forEach(list => {
            list.classList.remove('disclosure__list--visible');
          });
          langButtons.forEach(button => {
            button.setAttribute('aria-expanded', 'false');
          });
        }
      });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      
      // Also close language dropdown
      document.querySelectorAll('[data-lang-list]').forEach(list => {
        list.classList.remove('disclosure__list--visible');
      });
      document.querySelectorAll('[data-lang-selector]').forEach(button => {
        button.setAttribute('aria-expanded', 'false');
      });
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
